import { Control, useFieldArray } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { v4 as uuidv4 } from 'uuid';
import PaperSection from '@rossum/components/paper-section/PaperSection';
import { IconPlus } from '@rossum/ui/icons/tabler';
import { Button, Stack, SvgIcon, Typography } from '@rossum/ui/material';
import { EditModeFormValues } from '../editModeFormType';
import { EditValueRow } from './EditValueRow';

type EditValuesEditorProps = {
  control: Control<EditModeFormValues>;
};

export const EditValuesEditor = ({ control }: EditValuesEditorProps) => {
  const intl = useIntl();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'uiEditValues',
  });

  return (
    <PaperSection
      title={intl.formatMessage({
        id: 'features.queueSettings.editMode.editValues.title',
      })}
      dataCy="edit-mode-edit-values-section"
    >
      <Stack spacing={2} sx={{ width: 1 }}>
        <Typography variant="body2" color="text.secondary">
          {intl.formatMessage({
            id: 'features.queueSettings.editMode.editValues.description',
          })}
        </Typography>
        {fields.map((field, index) => (
          <EditValueRow
            key={field.id}
            control={control}
            index={index}
            onRemove={() => remove(index)}
          />
        ))}
        <Stack direction="row">
          <Button
            variant="outlined"
            color="secondary"
            startIcon={
              <SvgIcon fontSize="small">
                <IconPlus />
              </SvgIcon>
            }
            onClick={() =>
              append({
                id: `edit:value_${uuidv4().slice(0, 8)}`,
                label: '',
                required: false,
                dataType: 'string',
                enumOptions: [],
              })
            }
            data-cy="edit-mode-add-edit-value"
          >
            {intl.formatMessage({
              id: 'features.queueSettings.editMode.editValues.add',
            })}
          </Button>
        </Stack>
      </Stack>
    </PaperSection>
  );
};
